import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "@helpers/translate";
import "./index.sass";

export const TradingAccountCard = () => {
  const { __ } = useTranslation();

  const activeWallet = useSelector(
    (state) => state.wallet?.active_wallet ?? null,
  );

  const { avatar_url, full_name, display_id } = useSelector(
    (state) => state.user.user || {},
  );

  const balance = Number(activeWallet?.balance) || 0;

  return (
    <div className="trading-account-card">
      <div className="trading-account-card__details">
        <div className="trading-account-card__user">
          <div className="trading-account-card__avatar">
            <div className="trading-account-card__avatar-inner">
              {avatar_url ? (
                <img
                  src={avatar_url}
                  alt={full_name || "User"}
                />
              ) : (
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.0121 14.3333C12.8867 14.3333 10.3454 11.7907 10.3454 8.66667C10.3454 5.54267 12.8867 3 16.0121 3C19.1374 3 21.6787 5.54267 21.6787 8.66667C21.6787 11.7907 19.1374 14.3333 16.0121 14.3333ZM16.0121 5C13.9894 5 12.3454 6.644 12.3454 8.66667C12.3454 10.6893 13.9894 12.3333 16.0121 12.3333C18.0347 12.3333 19.6787 10.6893 19.6787 8.66667C19.6787 6.644 18.0334 5 16.0121 5ZM21.3293 29H10.6708C7.44409 29 5.66669 27.2334 5.66669 24.0254C5.66669 20.4774 7.67469 16.3333 13.3334 16.3333H18.6667C24.3254 16.3333 26.3334 20.4761 26.3334 24.0254C26.3334 27.2334 24.556 29 21.3293 29ZM13.3334 18.3333C8.07602 18.3333 7.66669 22.6894 7.66669 24.0254C7.66669 26.1107 8.56542 27 10.6708 27H21.3293C23.4346 27 24.3334 26.1107 24.3334 24.0254C24.3334 22.6907 23.924 18.3333 18.6667 18.3333H13.3334Z"
                    fill="white"
                  />
                </svg>
              )}
            </div>
          </div>

          <div className="trading-account-card__info">
            <h3 className="trading-account-card__name">
              {full_name}
            </h3>

            <span className="trading-account-card__uid">
              UID {display_id}
            </span>
          </div>
        </div>

        <div className="trading-account-card__balance">
          <p className="trading-account-card__balance-label">
            {__("common.balance")}
          </p>

          <p className="trading-account-card__balance-value">
            $
            {new Intl.NumberFormat("en-US", {
              minimumFractionDigits: balance === 0 ? 0 : 2,
              maximumFractionDigits: 2,
            }).format(balance)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TradingAccountCard;
